/**
 * @owner @Appboy/core-objects
 *
 * @fileoverview GET handler for the "/apps/catalog_items" endpoint
 */
import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogItems } from "./constants";
import type { AppsCatalogItemsResult, GetAppsCatalogItemsParams } from "@dashboardApi/apis/appsCatalogItems/types";

export const getAppsCatalogItems = reactQueryFetcherAdapter(
  appsCatalogItems,
  (signal: AbortSignal, params: GetAppsCatalogItemsParams): Promise<AppsCatalogItemsResult> => {
    return fetch(`/apps/catalog_items`, "GET", params, { signal });
  }
);
